<div class="unassigned-color-picker-container">
  <mode-color-swatch-flyout
    [selectedColorPalette]="currentPalette"
    [allColorPalettes]="allColorPalettes"
    [activeColor]="currentColor"
    [vizToken]="vizToken"
    (colorUpdated)="colorUpdated($event.colorSelected, $event.selectedPalette)"
  ></mode-color-swatch-flyout>
  <label class="unassigned-label">Unassigned values color</label>
</div>
